import { Component, ElementRef, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {
  title = 'app';
  constructor(private swUpdate: SwUpdate,private _elementRef: ElementRef) {}

  ngOnInit() {
    this._elementRef.nativeElement.removeAttribute("ng-version");
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {     
          window.location.reload();        
      });
    }
  }
}
